import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ThreeDots } from "react-loader-spinner";
import { DarkModeContext } from "../../context/DarkModeContext";
import BienvenidoPanel from "../comunes/BienvenidoPanel";
import ScrollToTopButton from "../comunes/ScrollToTopButton";
import TituloPagina from "../comunes/TituloPagina";
import Footer from "../comunes/Footer";
import logo from "../../assets/img/logo.png";
import logoClaro from "../../assets/img/logo-modo-oscuro.png";
import { getToken } from "../../utils/auth";


const apiUrlDemo = process.env.REACT_APP_API_TOKEN_DEMO;

const LayoutOperacionesAliado = ({ title, children, couponSearchVariant = false }) => {
  const { darkMode } = useContext(DarkModeContext);
  const navigate = useNavigate();
  const [validando, setValidando] = useState(true);
  const [autorizado, setAutorizado] = useState(false);

  useEffect(() => {
    validarAcceso();
  }, []);

  const validarAcceso = async () => {
    const token = getToken();
    if (!token) {
      redirigirSinAcceso();
      return;
    }

    setValidando(true);
    try {
      const response = await fetch(apiUrlDemo, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Token: token }),
      });

      if (response.status === 200) {
        setAutorizado(true);
        return;
      }

      redirigirSinAcceso();
    } catch (error) {
      redirigirSinAcceso();
    } finally {
      setValidando(false);
    }
  };

  const redirigirSinAcceso = () => {
    setAutorizado(false);
    Swal.fire({
      title: "Vista no disponible",
      text: "Esta sección no está habilitada momentáneamente para tu usuario",
      imageUrl: logo,
      imageWidth: 100,
      imageHeight: 30,
      imageAlt: "Logo",
      confirmButtonText: "OK",
      customClass: {
        container: darkMode ? "swal2-container--dark" : "swal2-container--light",
        confirmButton: "my-swal-button",
      },
    }).then(() => navigate("/aliados/inicio"));
  };

  if (validando) {
    return (
      <div className="spinner-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div>
          <div>
            <img className="img-fluid logo-width-spinner" src={darkMode ? logoClaro : logo} alt="logo SOCO" />
          </div>
          <div className="ms-3">
            <ThreeDots visible height="60" width="60" color="#b4c400" radius="9" />
          </div>
        </div>
      </div>
    );
  }

  if (!autorizado) {
    return null;
  }

  if (couponSearchVariant) {
    return (
      <div translate="no" className={`operaciones-aliado-page ${darkMode ? "operaciones-aliado-page-dark" : ""}`}>
        <main className="operaciones-aliado-page-shell">
          <header className="operaciones-aliado-page-header">
            <div>
              <span>CRM Aliado</span>
              <h1>{title}</h1>
            </div>
            <time>
              {new Date().toLocaleDateString("es-AR")} | {new Date().toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" })}
            </time>
          </header>
          <ScrollToTopButton />
          <div className="operaciones-aliado-page-content">{children}</div>
          <div className="operaciones-aliado-page-footer"><Footer /></div>
        </main>
      </div>
    );
  }

  return (
    <div translate="no">
      <div className="d-xl-block d-none mt-4 pt-4 ">
        <BienvenidoPanel />
      </div>
      <ScrollToTopButton />
      <div className="pt-2">
        <TituloPagina title={title} />
      </div>
      <div className="container mt-4">{children}</div>
    </div>
  );
};

export default LayoutOperacionesAliado;
